<ng-container *ngIf="loading">
  <div class="container-with-loading">
      <div class="loading-overlay">
          <mat-spinner></mat-spinner>
      </div>
  </div>
</ng-container>


  <mat-card class="offer-card" appearance="outlined" [hidden]="loading">
    <!--mat-card-header>
      <mat-card-title>Revisar Firma</mat-card-title>
    </mat-card-header-->
    <mat-card-content>

      <form class="form-container" (ngSubmit)="onSubmitReviewRequestSignature(requestSignatureForm)" #requestSignatureForm="ngForm" >

        <mat-card class="general-wf-card" appearance="outlined">
          <mat-card-header>
            <mat-card-title>Datos Generales</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <!--div id="container" class="formControl">
              <div class="control">
                  <mat-form-field class="imput-full-width">
                    <mat-label>Folio</mat-label>
                    <input type="text" matInput name="offerSignatureRequested.folio" [(ngModel)]="offerSignatureRequested.folio" [readonly]="true">
                  </mat-form-field>
              </div>
            </div-->

            <div id="container" class="formControl">
        
              <div class="control">
                <mat-slide-toggle [(ngModel)]="isInTypeOffer" name="typeOffer" [disabled]="offerSignatureRequested.offer!.id !== 0">  
                  {{ isInTypeOffer? 'Oferta Interna':'Oferta Externa'}} 
                </mat-slide-toggle>
              </div>
              
              <div class="control">
                <mat-form-field class="imput-full-width">
                  <mat-label>Folio</mat-label>
                  <input type="text" matInput name="offerSignatureRequested.offer.folio" [(ngModel)]="offerSignatureRequested.offer!.folio" [readonly]="true">
                </mat-form-field>
              </div>
              <div class="control">
                <mat-form-field class="imput-full-width">
                  <mat-label>Estado Oferta</mat-label>
                  <input type="text" matInput name="offerSignatureRequested.offer.status.description" [(ngModel)]="offerSignatureRequested.offer!.status!.description" [readonly]="true">
                </mat-form-field>
              </div>

              <div class="control">
                <mat-slide-toggle [(ngModel)]="offerSignatureRequested.offer!.active" name="offerActive" [disabled]="offerSignatureRequested.offer!.id !== 0" >
                  {{ offerSignatureRequested.offer!.active? 'Oferta Activa':'Oferta Inactiva'}} 
                </mat-slide-toggle>
              </div>
            </div>

            <div id="container" class="formControl">
              @if(isInTypeOffer){
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Numero Empleado</mat-label>
                  <input matInput type="text" name="employeeNumber" [(ngModel)]="offerSignatureRequested.offer!.employee!.employeeNumber" [readonly]="true">
                    <!--(blur)="onEmployeeNumberChange(offerSignatureRequested.offer!.employee!.employeeNumber)"-->
                </mat-form-field>
              </div>        
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Nombre</mat-label>
                  <input matInput type="text" name="offerSignatureRequested.offer.employee.person.name" [(ngModel)]="offerSignatureRequested.offer!.employee!.person.name" [readonly]="true">
                </mat-form-field>
              </div>
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Apellido Paterno</mat-label>
                  <input matInput type="text" name="offerSignatureRequested.offer.employee.person.paternalSurname" [(ngModel)]="offerSignatureRequested.offer!.employee!.person.paternalSurname" [readonly]="true">
                </mat-form-field>
              </div>
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Apellido Materno</mat-label>
                  <input matInput type="text" name="offerSignatureRequested.offer.employee.person.maternalSurname" [(ngModel)]="offerSignatureRequested.offer!.employee!.person.maternalSurname" [readonly]="true">
                </mat-form-field>
              </div>
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Telefono</mat-label>
                  <input matInput type="text" name="offerSignatureRequested.offer.employee.person.telephone" [(ngModel)]="offerSignatureRequested.offer!.employee!.person.telephone" [readonly]="true">
                </mat-form-field>            
              </div>
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Cel</mat-label>
                  <input matInput type="text" name="offerSignatureRequested.offer.employee.person.cellPhone" [(ngModel)]="offerSignatureRequested.offer!.employee!.person.cellPhone" [readonly]="true">
                </mat-form-field>
              </div>
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Correo</mat-label>
                  <input type="email" matInput placeholder="Ex. pat@example.com" name="offerSignatureRequested.offer.employee.person.email" [(ngModel)]="offerSignatureRequested.offer!.employee!.person.email" [readonly]="true">
                </mat-form-field>
              </div>
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Fecha Nacimiento</mat-label>
                  <input matInput [matDatepicker]="picker" name="offerSignatureRequested.offer.employee.person.dateOfBirth" 
                  [(ngModel)]="offerSignatureRequested.offer!.employee!.person.dateOfBirth">
                  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
              </div>
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Edad</mat-label>
                  <input type="text" matInput name="offerSignatureRequested.offer.employee.person.years" [(ngModel)]="offerSignatureRequested.offer!.employee!.person.years" 
                  [readonly]="true">
                </mat-form-field>
              </div>

            } @else{
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Nombre</mat-label>
                  <input matInput type="text" name="offer_applicant_person_name" [(ngModel)]="offerSignatureRequested.offer!.applicant!.person.name" [readonly]="true">
                </mat-form-field>
              </div>
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Apellido Paterno</mat-label>
                  <input matInput type="text" name="offerSignatureRequested.offer.applicant.person.paternalSurname" 
                  [(ngModel)]="offerSignatureRequested.offer!.applicant!.person.paternalSurname" [readonly]="true">
                </mat-form-field>
              </div>
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Apellido Materno</mat-label>
                  <input matInput type="text" name="offerSignatureRequested.offer.applicant.person.maternalSurname" 
                  [(ngModel)]="offerSignatureRequested.offer!.applicant!.person.maternalSurname" [readonly]="true">
                </mat-form-field>
              </div>
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Telefono</mat-label>
                  <input matInput type="text" name="offerSignatureRequested.offer.applicant.person.telephone" [(ngModel)]="offerSignatureRequested.offer!.applicant!.person.telephone" [readonly]="true">
                </mat-form-field>
              </div>
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Cel</mat-label>
                  <input matInput type="text" name="offerSignatureRequested.offer.applicant.person.cellPhone" [(ngModel)]="offerSignatureRequested.offer!.applicant!.person.cellPhone" [readonly]="true">
                </mat-form-field>
              </div>
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Correo</mat-label>
                  <input type="email" matInput placeholder="Ex. pat@example.com" name="offerSignatureRequested.offer.applicant.person.email" 
                  [(ngModel)]="offerSignatureRequested.offer!.applicant!.person.email" [readonly]="true">
                </mat-form-field>
              </div>
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Fecha Nacimiento</mat-label>
                  <input matInput [matDatepicker]="picker2"  name="offerSignatureRequested.offer.applicant.person.dateOfBirth" [(ngModel)]="offerSignatureRequested.offer!.applicant!.person.dateOfBirth" [readonly]="true">
                  <mat-datepicker-toggle matIconSuffix [for]="picker2"> </mat-datepicker-toggle>
                  <mat-datepicker #picker2></mat-datepicker>
                </mat-form-field>
              </div>
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Edad</mat-label>
                  <input type="text" matInput name="offerSignatureRequested.offer.applicant.person.years" [(ngModel)]="offerSignatureRequested.offer!.applicant!.person.years" 
                  [readonly]="true">
                </mat-form-field>
              </div>
              }

              
            </div> 
            
          </mat-card-content>
        </mat-card>
        <br>
        <mat-card class="general-wf-card" appearance="outlined">
          <mat-card-header>
            <mat-card-title>Propuesta</mat-card-title>
          </mat-card-header>
          <mat-card-content>

            <pdf-viewer
              *ngIf="pdfSrc"
              [src]="pdfSrc"
              [render-text]="true"
              [original-size]="false"
              [fit-to-page]="true"
              style="display: block; height: 600px;">
            </pdf-viewer>

          </mat-card-content>
        </mat-card>
        <br>
        <mat-card class="general-wf-card" appearance="outlined">
          <mat-card-header>
            <mat-card-title>Acciones Firma</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div id="container" class="formControl">
              <div class="control">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Revision</mat-label>
                  <mat-select [(ngModel)]="offerSignatureRequested.status.code"  name="statusSignature" [disabled]="!signatureSol">
                      <mat-option value="SOL"> Solicitada </mat-option>
                      <mat-option value="REC"> Registrada </mat-option>
                      <mat-option value="RECH">Rechazada</mat-option>
                      <mat-option value="AUT">Autorizada</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div id="container" class="formControl">
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Comentarios</mat-label>
                  <textarea matInput placeholder="Comentarios" name="offerSignatureRequested.observations" [(ngModel)]="offerSignatureRequested.observations" [readonly]="!signatureSol"></textarea>
                  <mat-error>{{ violations['offerSignatureRequested.observations'] }}</mat-error>
                </mat-form-field>


                @if(signatureSol){
                  <div class="control">
                    <button mat-flat-button class="button buttonWidth">
                      Enviar revision
                    </button>
                  </div>
                }
              </div>
          </div>
          </mat-card-content>
        </mat-card>
      </form>
    </mat-card-content>
  </mat-card>
